exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".status-icon[data-v-05ace6cf]{width:48px;height:21px;display:inline-block;vertical-align:middle;background:url(" + require("images/icons/status-tips.png") + ") no-repeat 0 0}.status-icon.undetermined[data-v-05ace6cf]{background-position:0 -31px}.status-icon.lh[data-v-05ace6cf]{background-position:0 -62px}.status-icon.not-deal[data-v-05ace6cf]{background-position:0 -93px}.status-icon.fq[data-v-05ace6cf]{background-position:0 -125px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05ace6cf","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/statusIcon.vue
// module id = 921
// module chunks = 23